module.exports = __webpack_public_path__ + "static/img/nextbeat_logo.a5465bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nextbeat_logo.png
// module id = TElK
// module chunks = 1